import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const StyledFlexColumnsWrapper = styled.main`
  width: 715px;
  height: 100%;

  & > :last-child {
    /* height: 100%; */
  }

  & .no-list tr[data-row='no-data' i] {
    height: 480px;
  }
`;

export const RightButtonSection = styled.section`
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: 0;
`;

export const BackButtonStyle = css`
  width: 124px;
  border-color: #999999;
  margin-bottom: 20px;
  color: #999999;
  margin: 0 5px;
  :hover {
    background-color: rgba(153, 153, 153, 0.2);
  }
  :active {
    background: #999999;
  }
`;
